// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import design system fonts */

/* 1. Use a more-intuitive box-sizing model */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* 2. Remove default margin and padding */
* {
  margin: 0;
  padding: 0;
}

/* 3. Enable keyword animations */
@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  /* 4. Add accessible line-height */
  line-height: 1.5;
  /* 5. Improve text rendering */
  -webkit-font-smoothing: antialiased;
  /* 6. Apply design system font */
  font-family: "Montserrat", system-ui, -apple-system, sans-serif;
}

/* 6. Improve media defaults */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* 7. Inherit fonts for form controls */
input,
button,
textarea,
select {
  font: inherit;
}

/* 8. Avoid text overflows */
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

/* 9. Improve line wrapping */
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

/*
  10. Create a root stacking context
*/
#root,
#__next {
  isolation: isolate;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

math {
  display: inline-flex;
  align-items: center;
  padding: 0.25em;
  gap: 0.25em;
  flex-wrap: wrap;
  row-gap: 0.5em;
}
mjx-container mjx-math {
  white-space: normal;
  line-height: 0.5;
}

/* Toast (Sonner headless) */
.sa-toast {
  background: #fcfcfc;
  border: 2px solid #3c8dcb;
  color: #3c8dcb;
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 320px;
  max-width: 420px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.sa-toast [data-icon] {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
}

.sa-toast [data-content] {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
  color: inherit;
}

.sa-toast__title {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.4;
  color: inherit;
}

.sa-toast__description {
  font-size: 13px;
  line-height: 1.4;
  color: inherit;
}

.sa-toast__close {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.sa-toast__close:hover {
  opacity: 1;
}

.sa-toast__action,
.sa-toast__cancel {
  border-radius: 8px;
  border: 1px solid currentColor;
  padding: 6px 10px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-weight: 600;
}

.sa-toast--error {
  background: #fcfcfc;
  border: 2px solid #ef4949a3;
  color: #ef4949;
}

.sa-toast--success {
  background: #fcfcfc;
  border: 2px solid #00966da3;
  color: #00966d;
}

.sa-toast--info {
  background: #fcfcfc;
  border: 2px solid #3c8dcb;
  color: #3c8dcb;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAG/B,6CAA6C;AAC7C;;;EAGE,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,SAAS;EACT,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;EAChC,+DAA+D;AACjE;;AAEA,8BAA8B;AAC9B;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;;EAIE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;;;;;;EAME,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["/* Import design system fonts */\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap\");\n\n/* 1. Use a more-intuitive box-sizing model */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* 2. Remove default margin and padding */\n* {\n  margin: 0;\n  padding: 0;\n}\n\n/* 3. Enable keyword animations */\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  /* 4. Add accessible line-height */\n  line-height: 1.5;\n  /* 5. Improve text rendering */\n  -webkit-font-smoothing: antialiased;\n  /* 6. Apply design system font */\n  font-family: \"Montserrat\", system-ui, -apple-system, sans-serif;\n}\n\n/* 6. Improve media defaults */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\n/* 7. Inherit fonts for form controls */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* 8. Avoid text overflows */\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\n/* 9. Improve line wrapping */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n/*\n  10. Create a root stacking context\n*/\n#root,\n#__next {\n  isolation: isolate;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\nmath {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25em;\n  gap: 0.25em;\n  flex-wrap: wrap;\n  row-gap: 0.5em;\n}\nmjx-container mjx-math {\n  white-space: normal;\n  line-height: 0.5;\n}\n\n/* Toast (Sonner headless) */\n.sa-toast {\n  background: #fcfcfc;\n  border: 2px solid #3c8dcb;\n  color: #3c8dcb;\n  border-radius: 12px;\n  padding: 12px 14px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 320px;\n  max-width: 420px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n}\n\n.sa-toast [data-icon] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  line-height: 0;\n}\n\n.sa-toast [data-content] {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n  color: inherit;\n}\n\n.sa-toast__title {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.4;\n  color: inherit;\n}\n\n.sa-toast__description {\n  font-size: 13px;\n  line-height: 1.4;\n  color: inherit;\n}\n\n.sa-toast__close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  width: 20px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  flex-shrink: 0;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.sa-toast__close:hover {\n  opacity: 1;\n}\n\n.sa-toast__action,\n.sa-toast__cancel {\n  border-radius: 8px;\n  border: 1px solid currentColor;\n  padding: 6px 10px;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.sa-toast--error {\n  background: #fcfcfc;\n  border: 2px solid #ef4949a3;\n  color: #ef4949;\n}\n\n.sa-toast--success {\n  background: #fcfcfc;\n  border: 2px solid #00966da3;\n  color: #00966d;\n}\n\n.sa-toast--info {\n  background: #fcfcfc;\n  border: 2px solid #3c8dcb;\n  color: #3c8dcb;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
